/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from 'react';
import {I18n} from 'react-redux-i18n';
import Icon from '@material-ui/core/Icon';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import {get} from 'lodash';

class DriverReport extends React.PureComponent {
  renderEmpty() {
    const {isLoading, list} = this.props;
    if (!isLoading && list.length <= 0) {
      return (
        <TableRow>
          <TableCell>
            <span className="reports__infomsg">
              <Icon className="reports__infomsg-icon">info</Icon>
              {I18n.t('page.reports.emptyMessage')}
            </span>
          </TableCell>
        </TableRow>
      );
    }

    return null;
  }

  render() {
    const {
      isLoading, list, totals, showPrimary, showSecondary
    } = this.props;
    return (
      <React.Fragment>
        {!isLoading && (
          <Table id="reportHeaderTable" className="reports__tableheader">
            <TableHead>
              <TableRow>
                <TableCell colSpan="14">
                  <h2 id="reportTitle" className="reports__title">
                    {I18n.t('page.reports.videoSummaryByDriver')}
                  </h2>
                </TableCell>
              </TableRow>
              <TableRow className="table__head">
                <TableCell>{I18n.t('page.reports.column.driverName')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.driverID')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.terminalName')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.videos')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.tagged')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.unreviewed')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.reviewed')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.reviewedComplete')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.coached')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.severity1')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.severity2')}</TableCell>
                <TableCell>{I18n.t('page.reports.column.recognition')}</TableCell>
                {showPrimary && <TableCell>{I18n.t('page.reports.column.primary')}</TableCell>}
                {showSecondary && <TableCell>{I18n.t('page.reports.column.secondary')}</TableCell>}
              </TableRow>
              <TableRow id="reportGrandTotal" className="reports__tablerow-grandtotal">
                <TableCell>{I18n.t('page.reports.column.grandTotal')}</TableCell>
                <TableCell>--</TableCell>
                <TableCell>--</TableCell>
                <TableCell className="columnMedias">{totals.medias}</TableCell>
                <TableCell className="columnTagged">{totals.tagged}</TableCell>
                <TableCell className="columnUnreviewed">{get(totals, 'unreviewed', 0)}</TableCell>
                <TableCell className="columnReviewed">{totals.reviewed}</TableCell>
                <TableCell className="columnReviewCompleted">{totals.reviewCompleted}</TableCell>
                <TableCell className="columnCoached">{totals.coached}</TableCell>
                <TableCell className="columnSeverity1">{get(totals, 'severity1', 0)}</TableCell>
                <TableCell className="columnSeverity2">{get(totals, 'severity2', 0)}</TableCell>
                <TableCell className="columnRecognition">{get(totals, 'recognition', 0)}</TableCell>
                {showPrimary && <TableCell className="columnPrimary">{get(totals, 'primary', 0)}</TableCell>}
                {showSecondary && <TableCell className="columnSecondary">{get(totals, 'secondary', 0)}</TableCell>}
              </TableRow>
            </TableHead>
          </Table>
        )}
        {!isLoading && (
          <Table id="reportResultTable" className="reports__tablerow">
            <TableBody>
              {this.renderEmpty()}
              {
                list.map((e, i) => (
                  <TableRow key={`driver-${i}`} className={`reportRow reportRow_${i}`}>
                    <TableCell className="columnDriver">
                      <a href="javascript:;" onClick={this.props.addFilterDriver(e.key, e.driverName, e.driverLogin)}>{e.driverName}</a>
                    </TableCell>
                    <TableCell className="columnDriver">{get(e, 'driverLogin', '--')}</TableCell>
                    <TableCell className="columnTerminal">{get(e, 'terminalName', '--')}</TableCell>
                    <TableCell className="columnMedias">{e.medias}</TableCell>
                    <TableCell className="columnTagged">{e.tagged}</TableCell>
                    <TableCell className="columnUnreviewed">{get(e, 'unreviewed', 0)}</TableCell>
                    <TableCell className="columnReviewed">{e.reviewed}</TableCell>
                    <TableCell className="columnReviewCompleted">{e.reviewCompleted}</TableCell>
                    <TableCell className="columnCoached">{e.coached}</TableCell>
                    <TableCell className="columnSeverity1">{get(e, 'severity1', 0)}</TableCell>
                    <TableCell className="columnSeverity2">{get(e, 'severity2', 0)}</TableCell>
                    <TableCell className="columnRecognition">{get(e, 'recognition', 0)}</TableCell>
                    {showPrimary && <TableCell className="columnPrimary">{get(e, 'primary', 0)}</TableCell>}
                    {showSecondary && <TableCell className="columnSecondary">{get(e, 'secondary', 0)}</TableCell>}
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        )}
      </React.Fragment>
    );
  }
}

export default DriverReport;
